import { FC } from "react";
import { Link } from "react-router-dom";

const SuccessPage: FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <h1 className="text-2xl font-bold text-green-600 mb-4">
          Order Processed Successfully!
        </h1>
        <p className="text-gray-600 mb-6">
          Thank you for your purchase. You’ll receive a confirmation soon.
        </p>
        <Link
          to="/"
          className="inline-block bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage;
